import React from 'react';

const Header = () => {
	return (
		<div className="Section -header">
			<div className="Section__content">
				<div className="UserCard">
					<div className="UserCard__avatar">
						<img src="/img/avatar.png" alt="/me" />
					</div>
					<div className="UserCard__name">
						Maxim Pokrovskii
					</div>
					<div className="UserCard__position">
						VCTO | Full Stack Developer | Meteor.js | SPA | Web Products
					</div>
					<div className="UserCard__description">
						<p>Hello! I'm a full stack developer who was born in Russia and currently based in Thailand.</p>
						<p>I am specializing in high-quality Single Page Applications and Website Development</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Header;



// WEBPACK FOOTER //
// ./src/header.js